import { Image, Text, View } from '@react-pdf/renderer';

import LampDiagramImage from '../../../../../../src/assets/LampDiagramImage.png';
import { LampData, LampDetail } from '../../pdfData';
import styles from './LampDetailsStyles.ts';

const LampDetails = ({ lampData }: { lampData: LampData }) => {
  const photometryOrder = ['isocandela', 'isoilluminance'];
  const orderedImages = [...lampData.images].sort((a, b) => {
    const aIndex = photometryOrder.indexOf(a.photometry);
    const bIndex = photometryOrder.indexOf(b.photometry);
    if (aIndex !== -1 || bIndex !== -1) {
      return (aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex) - (bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex);
    }
    return a.photometry.localeCompare(b.photometry);
  });

  const plotImageStyle = (photometry: string) =>
    photometry === 'isocandela' ? styles.candelaImage : styles.illuminanceImage;

  return (
    <View style={styles.container}>
      <Text style={styles.titleContent}>{lampData.firstPage && 'Product Information'}</Text>

      <View style={styles.header}>
        <Text style={styles.reportTitle}>{lampData.header}</Text>
      </View>

      <View style={styles.description}>
        <Image style={styles.diagramImage} src={LampDiagramImage} />
      </View>

      <View style={styles.table}>
        <View style={styles.column}>
          {lampData.details.leftColumn.map((item: LampDetail, index) => (
            <View key={index} style={styles.row}>
              <Text style={styles.label}>{item.label}:</Text>
              <Text style={styles.value}>{item.value}</Text>
            </View>
          ))}
        </View>

        <View style={styles.column}>
          {lampData.details.rightColumn.map((item: LampDetail, index) => (
            <View key={index} style={styles.row}>
              <Text style={styles.label}>{item.label}:</Text>
              <Text style={styles.value}>{item.value}</Text>
            </View>
          ))}
        </View>
      </View>

      <View style={styles.imageContent}>
        {orderedImages.map((image, index) => (
          <View key={index} style={styles.plotBlock}>
            <Image style={plotImageStyle(image.photometry)} src={image.url} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default LampDetails;
